import { computed } from 'vue';
import apiClient from '@/axios';
import { Teacher } from '@/models/models';

const userId = computed(() => JSON.parse(localStorage.getItem('user') || '{}')).value.userId;

export const updatePassword = (data: { initialPassword: string; newPassword: string }) => apiClient.post("/user/updatePassword/", data);